import React from "react";

import DesktopPrimaryLayout from "@/features/layouts/DesktopPrimaryLayout";
import UserInfoDisplay from "@/features/user/UserInfoDisplay";
import { DEVICE_BREAKPOINT, useResponsive } from "@/styles";
import Card from "@/components/data/Card";

import { StyledPage } from "./ProfilePage.styles";
import ProfileTabs from "./components/ProfileTabs";
import ProfileSummarySection from "./components/ProfileSummarySection";
import TimezoneDisplay from "./components/TimezoneDisplay";
import LanguagesDisplay from "./components/LanguagesDisplay";
import SocialLinksDisplay from "./components/SocialLinksDisplay";

const ProfilePage: React.FC = () => {
  const { screenWidth } = useResponsive();

  return (
    <DesktopPrimaryLayout
      headerProps={{ logo: { component: "Profile" } }}
    >
      <StyledPage>
        {screenWidth < DEVICE_BREAKPOINT.widescreen ? (
          <>
            <UserInfoDisplay />
            <ProfileSummarySection className="mt-3" />
            <ProfileTabs className="mt-4" />
          </>
        ) : (
          <>
            <Card>
              <UserInfoDisplay />
              <ProfileSummarySection className="mt-3" />
              <TimezoneDisplay className="mt-4" />
              <LanguagesDisplay className="mt-3" />
              <SocialLinksDisplay className="mt-4" />
            </Card>
            <Card>
              <ProfileTabs />
            </Card>
          </>
        )}
      </StyledPage>
    </DesktopPrimaryLayout>
  );
};

export default ProfilePage;
